import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
  ByteSerializer_getInstance20v1505to7w0y as ByteSerializer_getInstance,
  ShortSerializer_getInstance1sui2olw3dzs8 as ShortSerializer_getInstance,
  LongSerializer_getInstancepwtz4tlewrfw as LongSerializer_getInstance,
  FloatSerializer_getInstance1c6yoefuaocts as FloatSerializer_getInstance,
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
  CharSerializer_getInstancehi0q1kl0h8cw as CharSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  LinkedHashMapSerializermaoj2nyji7op as LinkedHashMapSerializer,
  ArrayListSerializer7k5wnrulb3y6 as ArrayListSerializer,
  LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { DefaultSerializableAnnotationParsers_getInstance1th3cnu15ruw9 as DefaultSerializableAnnotationParsers_getInstance } from './DefaultSerializableAnnotationParsers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getBigIntHashCode294hi5bdhtj6e as getBigIntHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  removePrefix279df90bhrqqg as removePrefix,
  substringBeforekje8w2lxhyb6 as substringBefore,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { reflectAnnotation3vd82vtja4yiy as reflectAnnotation } from './SerializationHacks.nonJvm.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { endsWith3cq61xxngobwh as endsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  constructCallableReference23y65rf941mch as constructCallableReference,
  getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { KSerializerWithDefault3c244bl47fg5p as KSerializerWithDefault } from './Defaults.mjs';
import { ENUM_getInstance25239ht7oag6o as ENUM_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
  get_annotationshjxdbdcl8kmv as get_annotations,
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptor.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ObjectSerializer2kjkucmygguwd as ObjectSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/ObjectSerializer.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString_0,
  Char__hashCode_impl_otmys1an6rit7zu1bt as Char__hashCode_impl_otmys,
  Char19o2r8palgjof as Char,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { SealedClassSerializeriwipiibk55zc as SealedClassSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SealedSerializer.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import {
  isArray1hxjqtqy632bc as isArray,
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
  isInterface3d6p8outrmvmk as isInterface,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { isLongArray21mxwb8b0y2ii as isLongArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { serializerOrNull294cbc318ws50 as serializerOrNull } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KClass1cc9rfeybg8hs as KClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KClassJs.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function SerializableAnnotation$Companion$$childSerializers$_anonymous__haf4po() {
  return new (LinkedHashMapSerializer())(StringSerializer_getInstance(), Companion_getInstance_20().serializer_9w0wvi_k$());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, SerializableAnnotation$Companion$$childSerializers$_anonymous__haf4po)];
        this.__do_not_use_externally__parsers_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.__defaults_loaded___1 = DefaultSerializableAnnotationParsers_getInstance();
      }
      parser_6f5ibw_k$(name, handler) {
        var tmp0 = this.__do_not_use_externally__parsers_1;
        // Inline function 'kotlin.collections.set' call
        var value = typeof handler === 'function' ? handler : THROW_CCE();
        tmp0.put_4fpzoq_k$(name, value);
      }
      parseOrNull_evcrzc_k$(annotation) {
        var fqn = substringBefore(removePrefix(toString(annotation), '@'), '(');
        var tmp0_safe_receiver = this.__do_not_use_externally__parsers_1.get_wei43m_k$(fqn);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver(annotation);
        return tmp1_elvis_lhs == null ? reflectAnnotation(annotation) : tmp1_elvis_lhs;
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotation', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('fqn', false);
        tmp0_serialDesc.addElement_5pzumi_k$('values', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_w79nas_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.fqn_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.values_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_w79nas_k$(encoder, value instanceof SerializableAnnotation() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp7_cached = Companion_getInstance().$childSerializers_1;
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp7_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SerializableAnnotation().new_com_lightningkite_services_database_SerializableAnnotation_m9j0d4_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var SerializableAnnotationClass;
function SerializableAnnotation() {
  if (SerializableAnnotationClass === VOID) {
    class $ {
      constructor(fqn, values) {
        Companion_getInstance();
        this.fqn_1 = fqn;
        this.values_1 = values;
      }
      toString() {
        return 'SerializableAnnotation(fqn=' + this.fqn_1 + ', values=' + toString(this.values_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.fqn_1);
        result = imul(result, 31) + hashCode(this.values_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SerializableAnnotation()))
          return false;
        if (!(this.fqn_1 === other.fqn_1))
          return false;
        if (!equals(this.values_1, other.values_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotation_m9j0d4_k$(seen0, fqn, values, serializationConstructorMarker) {
        Companion_getInstance();
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        $this.fqn_1 = fqn;
        $this.values_1 = values;
        return $this;
      }
    }
    initMetadataForClass($, 'SerializableAnnotation', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    SerializableAnnotationClass = $;
  }
  return SerializableAnnotationClass;
}
function VirtualField$Companion$$childSerializers$_anonymous__4z6o3p() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, null, null, lazy(tmp_0, VirtualField$Companion$$childSerializers$_anonymous__4z6o3p), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualField', this, 7);
        tmp0_serialDesc.addElement_5pzumi_k$('index', false);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('type', false);
        tmp0_serialDesc.addElement_5pzumi_k$('optional', false);
        tmp0_serialDesc.addElement_5pzumi_k$('annotations', false);
        tmp0_serialDesc.addElement_5pzumi_k$('defaultJson', true);
        tmp0_serialDesc.addElement_5pzumi_k$('defaultCode', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_s4r3ud_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 0, value.index_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.name_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_1(), value.type_1);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 3, value.optional_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.annotations_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.defaultJson_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, StringSerializer_getInstance(), value.defaultJson_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.defaultCode_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, StringSerializer_getInstance(), value.defaultCode_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_s4r3ud_k$(encoder, value instanceof VirtualField() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = false;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp12_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp11_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp11_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp11_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp11_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp11_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp11_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp11_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp12_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, StringSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp11_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, StringSerializer_getInstance(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp11_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualField().new_com_lightningkite_services_database_VirtualField_bdqh7n_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance(), StringSerializer_getInstance(), $serializer_getInstance_1(), BooleanSerializer_getInstance(), tmp0_cached[4].get_value_j01efc_k$(), get_nullable(StringSerializer_getInstance()), get_nullable(StringSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var VirtualFieldClass;
function VirtualField() {
  if (VirtualFieldClass === VOID) {
    class $ {
      constructor(index, name, type, optional, annotations, defaultJson, defaultCode) {
        Companion_getInstance_0();
        defaultJson = defaultJson === VOID ? null : defaultJson;
        defaultCode = defaultCode === VOID ? null : defaultCode;
        this.index_1 = index;
        this.name_1 = name;
        this.type_1 = type;
        this.optional_1 = optional;
        this.annotations_1 = annotations;
        this.defaultJson_1 = defaultJson;
        this.defaultCode_1 = defaultCode;
      }
      toString() {
        return this.name_1 + ': ' + this.type_1.toString();
      }
      hashCode() {
        var result = this.index_1;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + this.type_1.hashCode() | 0;
        result = imul(result, 31) + getBooleanHashCode(this.optional_1) | 0;
        result = imul(result, 31) + hashCode(this.annotations_1) | 0;
        result = imul(result, 31) + (this.defaultJson_1 == null ? 0 : getStringHashCode(this.defaultJson_1)) | 0;
        result = imul(result, 31) + (this.defaultCode_1 == null ? 0 : getStringHashCode(this.defaultCode_1)) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualField()))
          return false;
        if (!(this.index_1 === other.index_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!this.type_1.equals(other.type_1))
          return false;
        if (!(this.optional_1 === other.optional_1))
          return false;
        if (!equals(this.annotations_1, other.annotations_1))
          return false;
        if (!(this.defaultJson_1 == other.defaultJson_1))
          return false;
        if (!(this.defaultCode_1 == other.defaultCode_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualField_bdqh7n_k$(seen0, index, name, type, optional, annotations, defaultJson, defaultCode, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(31 === (31 & seen0))) {
          throwMissingFieldException(seen0, 31, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.index_1 = index;
        $this.name_1 = name;
        $this.type_1 = type;
        $this.optional_1 = optional;
        $this.annotations_1 = annotations;
        if (0 === (seen0 & 32))
          $this.defaultJson_1 = null;
        else
          $this.defaultJson_1 = defaultJson;
        if (0 === (seen0 & 64))
          $this.defaultCode_1 = null;
        else
          $this.defaultCode_1 = defaultCode;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualField', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    VirtualFieldClass = $;
  }
  return VirtualFieldClass;
}
function VirtualTypeReference$Companion$$childSerializers$_anonymous__lthuf8() {
  return new (ArrayListSerializer())($serializer_getInstance_1());
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, VirtualTypeReference$Companion$$childSerializers$_anonymous__lthuf8), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualTypeReference', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('serialName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('arguments', false);
        tmp0_serialDesc.addElement_5pzumi_k$('isNullable', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_edbgek_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.serialName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.arguments_1);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 2, value.isNullable_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_edbgek_k$(encoder, value instanceof VirtualTypeReference() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = false;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualTypeReference().new_com_lightningkite_services_database_VirtualTypeReference_om6czq_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
function VirtualTypeReference$toString$lambda(it) {
  return it.toString();
}
var VirtualTypeReferenceClass;
function VirtualTypeReference() {
  if (VirtualTypeReferenceClass === VOID) {
    class $ {
      constructor(serialName, arguments_0, isNullable) {
        Companion_getInstance_1();
        this.serialName_1 = serialName;
        this.arguments_1 = arguments_0;
        this.isNullable_1 = isNullable;
        if (endsWith(this.serialName_1, '?'))
          throw Exception().new_kotlin_Exception_f32mds_k$();
      }
      toString() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.arguments_1;
        var tmp;
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = joinToString(tmp0_safe_receiver, ', ', '<', '>', VOID, VOID, VirtualTypeReference$toString$lambda);
        }
        var tmp1_elvis_lhs = tmp_0;
        return this.serialName_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + (this.isNullable_1 ? '?' : '');
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(result, 31) + hashCode(this.arguments_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.isNullable_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualTypeReference()))
          return false;
        if (!(this.serialName_1 === other.serialName_1))
          return false;
        if (!equals(this.arguments_1, other.arguments_1))
          return false;
        if (!(this.isNullable_1 === other.isNullable_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualTypeReference_om6czq_k$(seen0, serialName, arguments_0, isNullable, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.serialName_1 = serialName;
        $this.arguments_1 = arguments_0;
        $this.isNullable_1 = isNullable;
        if (endsWith($this.serialName_1, '?'))
          throw Exception().new_kotlin_Exception_f32mds_k$();
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualTypeReference', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    VirtualTypeReferenceClass = $;
  }
  return VirtualTypeReferenceClass;
}
function VirtualStruct$Concrete$_get_serializableProperties_$ref_24cqpv() {
  return constructCallableReference((p0) => p0.get_serializableProperties_zfjiw5_k$(), 1, 0, 152);
}
function VirtualStruct$Companion$$childSerializers$_anonymous__6newk6() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_0() {
  return new (ArrayListSerializer())($serializer_getInstance_0());
}
function VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_1() {
  return new (ArrayListSerializer())($serializer_getInstance_4());
}
var ConcreteClass;
function Concrete() {
  if (ConcreteClass === VOID) {
    class $ {
      get_serializableProperties_zfjiw5_k$() {
        var tmp0 = this.serializableProperties$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializableProperties', 1, tmp, VirtualStruct$Concrete$_get_serializableProperties_$ref_24cqpv(), null);
        return tmp0.get_value_j01efc_k$();
      }
    }
    initMetadataForClass($, 'Concrete', VOID, VOID, [KSerializer(), VirtualType(), KSerializerWithDefault()]);
    ConcreteClass = $;
  }
  return ConcreteClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, VirtualStruct$Companion$$childSerializers$_anonymous__6newk6);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, tmp_1, tmp_3, lazy(tmp_4, VirtualStruct$Companion$$childSerializers$_anonymous__6newk6_1), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualStruct', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('serialName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('annotations', false);
        tmp0_serialDesc.addElement_5pzumi_k$('fields', false);
        tmp0_serialDesc.addElement_5pzumi_k$('parameters', false);
        tmp0_serialDesc.addElement_5pzumi_k$('idField', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_vow68f_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.serialName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.annotations_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.fields_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.parameters_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.find' call
          var tmp0 = value.fields_1;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.name_1 === '_id') {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          var tmp$ret$0 = tmp$ret$1;
          tmp = !equals(value.idField_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 4, $serializer_getInstance_0(), value.idField_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vow68f_k$(encoder, value instanceof VirtualStruct() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp10_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp10_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 4, $serializer_getInstance_0(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualStruct().new_com_lightningkite_services_database_VirtualStruct_eef5i9_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_2().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), tmp0_cached[2].get_value_j01efc_k$(), tmp0_cached[3].get_value_j01efc_k$(), get_nullable($serializer_getInstance_0())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var $serializer_instance_2;
function $serializer_getInstance_2() {
  if ($serializer_instance_2 === VOID)
    new ($serializer_2())();
  return $serializer_instance_2;
}
function VirtualStruct$toString$lambda(it) {
  return it.name_1;
}
var VirtualStructClass;
function VirtualStruct() {
  if (VirtualStructClass === VOID) {
    class $ {
      constructor(serialName, annotations, fields, parameters) {
        Companion_getInstance_2();
        this.serialName_1 = serialName;
        this.annotations_1 = annotations;
        this.fields_1 = fields;
        this.parameters_1 = parameters;
        var tmp = this;
        // Inline function 'kotlin.collections.find' call
        var tmp0 = this.fields_1;
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
          while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
            var element = _iterator__ex2g4s.next_20eer_k$();
            if (element.name_1 === '_id') {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }
        tmp.idField_1 = tmp$ret$1;
      }
      get_annotations_20dirp_k$() {
        return this.annotations_1;
      }
      toString() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.parameters_1;
        var tmp;
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = joinToString(tmp0_safe_receiver, ', ', '<', '>', VOID, VOID, VirtualStruct$toString$lambda);
        }
        var tmp1_elvis_lhs = tmp_0;
        return 'virtual data class ' + this.serialName_1 + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs) + '(' + joinToString(this.fields_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(result, 31) + hashCode(this.annotations_1) | 0;
        result = imul(result, 31) + hashCode(this.fields_1) | 0;
        result = imul(result, 31) + hashCode(this.parameters_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualStruct()))
          return false;
        if (!(this.serialName_1 === other.serialName_1))
          return false;
        if (!equals(this.annotations_1, other.annotations_1))
          return false;
        if (!equals(this.fields_1, other.fields_1))
          return false;
        if (!equals(this.parameters_1, other.parameters_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualStruct_eef5i9_k$(seen0, serialName, annotations, fields, parameters, idField, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.serialName_1 = serialName;
        $this.annotations_1 = annotations;
        $this.fields_1 = fields;
        $this.parameters_1 = parameters;
        if (0 === (seen0 & 16)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.find' call
          var tmp0 = $this.fields_1;
          var tmp$ret$1;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
            while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
              var element = _iterator__ex2g4s.next_20eer_k$();
              if (element.name_1 === '_id') {
                tmp$ret$1 = element;
                break $l$block;
              }
            }
            tmp$ret$1 = null;
          }
          tmp.idField_1 = tmp$ret$1;
        } else
          $this.idField_1 = idField;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualStruct', VOID, VOID, [VirtualType()], VOID, VOID, {0: $serializer_getInstance_2});
    VirtualStructClass = $;
  }
  return VirtualStructClass;
}
var VirtualTypeClass;
function VirtualType() {
  if (VirtualTypeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'VirtualType');
    VirtualTypeClass = $;
  }
  return VirtualTypeClass;
}
function VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda_0() {
  return new (ArrayListSerializer())($serializer_getInstance_8());
}
var VirtualEnumDescriptorClass;
function VirtualEnumDescriptor() {
  if (VirtualEnumDescriptorClass === VOID) {
    class $ {
      constructor($outer) {
        this.$this_1 = $outer;
        this.kind_1 = ENUM_getInstance();
        this.serialName_1 = this.$this_1.serialName_1;
      }
      get_elementsCount_288r0x_k$() {
        return this.$this_1.options_1.get_size_woubt6_k$();
      }
      get_kind_wop7ml_k$() {
        return this.kind_1;
      }
      get_serialName_u2rqhk_k$() {
        return this.serialName_1;
      }
      getElementAnnotations_omrjs6_k$(index) {
        // Inline function 'kotlin.collections.listOf' call
        return emptyList();
      }
      getElementDescriptor_ncda77_k$(index) {
        return this;
      }
      getElementIndex_utfbym_k$(name) {
        var tmp0_safe_receiver = this.$this_1.map_1.get_wei43m_k$(name);
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.index_1;
        return tmp1_elvis_lhs == null ? -3 : tmp1_elvis_lhs;
      }
      getElementName_u4sqmf_k$(index) {
        return this.$this_1.options_1.get_c1px32_k$(index).name_1;
      }
      isElementOptional_heqq56_k$(index) {
        return false;
      }
      equals(other) {
        var tmp;
        if (other instanceof VirtualEnumDescriptor()) {
          tmp = other.serialName_1 === this.serialName_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return getStringHashCode(this.serialName_1);
      }
    }
    protoOf($).get_isNullable_67sy7o_k$ = get_isNullable;
    protoOf($).get_isInline_usk17w_k$ = get_isInline;
    protoOf($).get_annotations_20dirp_k$ = get_annotations;
    initMetadataForClass($, 'VirtualEnumDescriptor', VOID, VOID, [SerialDescriptor()]);
    VirtualEnumDescriptorClass = $;
  }
  return VirtualEnumDescriptorClass;
}
var CompanionClass_3;
function Companion_3() {
  if (CompanionClass_3 === VOID) {
    class $ {
      constructor() {
        Companion_instance_3 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, tmp_1, lazy(tmp_2, VirtualEnum$Companion$$childSerializers$_anonymous__3gjyda_0)];
        this.cache_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_3();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_3 = $;
  }
  return CompanionClass_3;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  if (Companion_instance_3 === VOID)
    new (Companion_3())();
  return Companion_instance_3;
}
var $serializerClass_3;
function $serializer_3() {
  if ($serializerClass_3 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_3 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualEnum', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('serialName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('annotations', false);
        tmp0_serialDesc.addElement_5pzumi_k$('options', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ksob47_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_3().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.serialName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.annotations_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.options_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ksob47_k$(encoder, value instanceof VirtualEnum() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp11_cached = Companion_getInstance_3().$childSerializers_1;
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp11_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp11_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp11_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp11_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualEnum().new_com_lightningkite_services_database_VirtualEnum_bfw59q_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_3().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), tmp0_cached[2].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_3 = $;
  }
  return $serializerClass_3;
}
var $serializer_instance_3;
function $serializer_getInstance_3() {
  if ($serializer_instance_3 === VOID)
    new ($serializer_3())();
  return $serializer_instance_3;
}
var VirtualEnumClass;
function VirtualEnum() {
  if (VirtualEnumClass === VOID) {
    class $ {
      constructor(serialName, annotations, options) {
        Companion_getInstance_3();
        this.serialName_1 = serialName;
        this.annotations_1 = annotations;
        this.options_1 = options;
        var tmp = this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.options_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = new (VirtualEnumValue())(this, item.index_1);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        tmp.entries_1 = destination;
        var tmp_0 = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_1 = this.options_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp$ret$5 = element.name_1;
          destination_0.put_4fpzoq_k$(tmp$ret$5, element);
        }
        tmp_0.map_1 = destination_0;
        this.descriptor_1 = new (VirtualEnumDescriptor())(this);
      }
      get_annotations_20dirp_k$() {
        return this.annotations_1;
      }
      toString() {
        return 'Virtual ' + this.serialName_1 + ' { ' + joinToString(this.options_1) + ' }';
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return this.entries_1.get_c1px32_k$(decoder.decodeEnum_slg6lu_k$(this.descriptor_1));
      }
      serialize_qug9v0_k$(encoder, value) {
        encoder.encodeEnum_2qin0y_k$(this.descriptor_1, value.index_1);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_qug9v0_k$(encoder, value instanceof VirtualEnumValue() ? value : THROW_CCE());
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(result, 31) + hashCode(this.annotations_1) | 0;
        result = imul(result, 31) + hashCode(this.options_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualEnum()))
          return false;
        if (!(this.serialName_1 === other.serialName_1))
          return false;
        if (!equals(this.annotations_1, other.annotations_1))
          return false;
        if (!equals(this.options_1, other.options_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualEnum_bfw59q_k$(seen0, serialName, annotations, options, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_3().descriptor_1);
        }
        var $this = createThis(this);
        $this.serialName_1 = serialName;
        $this.annotations_1 = annotations;
        $this.options_1 = options;
        var tmp = $this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = $this.options_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var item = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = new (VirtualEnumValue())($this, item.index_1);
          destination.add_utx5q5_k$(tmp$ret$2);
        }
        tmp.entries_1 = destination;
        var tmp_0 = $this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_1 = $this.options_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination_0 = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s_0 = this_1.iterator_jk1svi_k$();
        while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s_0.next_20eer_k$();
          var tmp$ret$5 = element.name_1;
          destination_0.put_4fpzoq_k$(tmp$ret$5, element);
        }
        tmp_0.map_1 = destination_0;
        $this.descriptor_1 = new (VirtualEnumDescriptor())($this);
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualEnum', VOID, VOID, [VirtualType(), KSerializer()], VOID, VOID, {0: $serializer_getInstance_3});
    VirtualEnumClass = $;
  }
  return VirtualEnumClass;
}
var CompanionClass_4;
function Companion_4() {
  if (CompanionClass_4 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_4();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_4 = $;
  }
  return CompanionClass_4;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  return Companion_instance_4;
}
var $serializerClass_4;
function $serializer_4() {
  if ($serializerClass_4 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_4 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualTypeParameter', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_6bng2e_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.name_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_6bng2e_k$(encoder, value instanceof VirtualTypeParameter() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualTypeParameter().new_com_lightningkite_services_database_VirtualTypeParameter_361w9d_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_4 = $;
  }
  return $serializerClass_4;
}
var $serializer_instance_4;
function $serializer_getInstance_4() {
  if ($serializer_instance_4 === VOID)
    new ($serializer_4())();
  return $serializer_instance_4;
}
var VirtualTypeParameterClass;
function VirtualTypeParameter() {
  if (VirtualTypeParameterClass === VOID) {
    class $ {
      constructor(name) {
        this.name_1 = name;
      }
      toString() {
        return 'VirtualTypeParameter(name=' + this.name_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.name_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualTypeParameter()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualTypeParameter_361w9d_k$(seen0, name, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_4().descriptor_1);
        }
        var $this = createThis(this);
        $this.name_1 = name;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualTypeParameter', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_4});
    VirtualTypeParameterClass = $;
  }
  return VirtualTypeParameterClass;
}
function VirtualSealed$Concrete$_get_serializableOptions_$ref_p89dsv() {
  return constructCallableReference((p0) => p0.get_serializableOptions_psql9y_k$(), 1, 0, 153);
}
function VirtualSealed$Companion$$childSerializers$_anonymous__l6fmxp() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
function VirtualSealed$Companion$$childSerializers$_anonymous__l6fmxp_0() {
  return new (ArrayListSerializer())($serializer_getInstance_7());
}
function VirtualSealed$Companion$$childSerializers$_anonymous__l6fmxp_1() {
  return new (ArrayListSerializer())($serializer_getInstance_4());
}
var ConcreteClass_0;
function Concrete_0() {
  if (ConcreteClass_0 === VOID) {
    class $ {
      get_serializableOptions_psql9y_k$() {
        var tmp0 = this.serializableOptions$delegate_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializableOptions', 1, tmp, VirtualSealed$Concrete$_get_serializableOptions_$ref_p89dsv(), null);
        return tmp0.get_value_j01efc_k$();
      }
    }
    initMetadataForClass($, 'Concrete', VOID, VOID, [KSerializerWithDefault(), VirtualType()]);
    ConcreteClass_0 = $;
  }
  return ConcreteClass_0;
}
var CompanionClass_5;
function Companion_5() {
  if (CompanionClass_5 === VOID) {
    class $ {
      constructor() {
        Companion_instance_5 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, VirtualSealed$Companion$$childSerializers$_anonymous__l6fmxp);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_3 = lazy(tmp_2, VirtualSealed$Companion$$childSerializers$_anonymous__l6fmxp_0);
        var tmp_4 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, tmp_1, tmp_3, lazy(tmp_4, VirtualSealed$Companion$$childSerializers$_anonymous__l6fmxp_1)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_5();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_5 = $;
  }
  return CompanionClass_5;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new (Companion_5())();
  return Companion_instance_5;
}
var $serializerClass_5;
function $serializer_5() {
  if ($serializerClass_5 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_5 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualSealed', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('serialName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('annotations', false);
        tmp0_serialDesc.addElement_5pzumi_k$('options', false);
        tmp0_serialDesc.addElement_5pzumi_k$('parameters', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_j88em0_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_5().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.serialName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.annotations_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.options_1);
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.listOf' call
          var tmp$ret$0 = emptyList();
          tmp = !equals(value.parameters_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, tmp2_cached[3].get_value_j01efc_k$(), value.parameters_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_j88em0_k$(encoder, value instanceof VirtualSealed() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp9_cached = Companion_getInstance_5().$childSerializers_1;
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp9_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp9_cached[3].get_value_j01efc_k$(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp9_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, tmp9_cached[3].get_value_j01efc_k$(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualSealed().new_com_lightningkite_services_database_VirtualSealed_gktj3g_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_5().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), tmp0_cached[2].get_value_j01efc_k$(), tmp0_cached[3].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_5 = $;
  }
  return $serializerClass_5;
}
var $serializer_instance_5;
function $serializer_getInstance_5() {
  if ($serializer_instance_5 === VOID)
    new ($serializer_5())();
  return $serializer_instance_5;
}
function VirtualSealed$toString$lambda(it) {
  return it.name_1;
}
function VirtualSealed$toString$lambda_0(it) {
  return it.name_1;
}
var VirtualSealedClass;
function VirtualSealed() {
  if (VirtualSealedClass === VOID) {
    class $ {
      constructor(serialName, annotations, options, parameters) {
        Companion_getInstance_5();
        var tmp;
        if (parameters === VOID) {
          // Inline function 'kotlin.collections.listOf' call
          tmp = emptyList();
        } else {
          tmp = parameters;
        }
        parameters = tmp;
        this.serialName_1 = serialName;
        this.annotations_1 = annotations;
        this.options_1 = options;
        this.parameters_1 = parameters;
      }
      get_annotations_20dirp_k$() {
        return this.annotations_1;
      }
      toString() {
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.parameters_1;
        var tmp;
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          tmp_0 = joinToString(tmp0_safe_receiver, ', ', '<', '>', VOID, VOID, VirtualSealed$toString$lambda);
        }
        var tmp1_elvis_lhs = tmp_0;
        var tmp_1 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
        return 'virtual sealed class ' + this.serialName_1 + tmp_1 + ' { ' + joinToString(this.options_1, VOID, VOID, VOID, VOID, VOID, VirtualSealed$toString$lambda_0) + ' }';
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(result, 31) + hashCode(this.annotations_1) | 0;
        result = imul(result, 31) + hashCode(this.options_1) | 0;
        result = imul(result, 31) + hashCode(this.parameters_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualSealed()))
          return false;
        if (!(this.serialName_1 === other.serialName_1))
          return false;
        if (!equals(this.annotations_1, other.annotations_1))
          return false;
        if (!equals(this.options_1, other.options_1))
          return false;
        if (!equals(this.parameters_1, other.parameters_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualSealed_gktj3g_k$(seen0, serialName, annotations, options, parameters, serializationConstructorMarker) {
        Companion_getInstance_5();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_5().descriptor_1);
        }
        var $this = createThis(this);
        $this.serialName_1 = serialName;
        $this.annotations_1 = annotations;
        $this.options_1 = options;
        if (0 === (seen0 & 8)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.listOf' call
          tmp.parameters_1 = emptyList();
        } else
          $this.parameters_1 = parameters;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualSealed', VOID, VOID, [VirtualType()], VOID, VOID, {0: $serializer_getInstance_5});
    VirtualSealedClass = $;
  }
  return VirtualSealedClass;
}
function VirtualAlias$Companion$$childSerializers$_anonymous__bh96hx() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_6;
function Companion_6() {
  if (CompanionClass_6 === VOID) {
    class $ {
      constructor() {
        Companion_instance_6 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, lazy(tmp_0, VirtualAlias$Companion$$childSerializers$_anonymous__bh96hx)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_6();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_6 = $;
  }
  return CompanionClass_6;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new (Companion_6())();
  return Companion_instance_6;
}
var $serializerClass_6;
function $serializer_6() {
  if ($serializerClass_6 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_6 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualAlias', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('serialName', false);
        tmp0_serialDesc.addElement_5pzumi_k$('wraps', false);
        tmp0_serialDesc.addElement_5pzumi_k$('annotations', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_nfkxdk_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_6().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.serialName_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance_1(), value.wraps_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.annotations_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_nfkxdk_k$(encoder, value instanceof VirtualAlias() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_6().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance_1(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, tmp8_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualAlias().new_com_lightningkite_services_database_VirtualAlias_mvatuw_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_6().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), $serializer_getInstance_1(), tmp0_cached[2].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_6 = $;
  }
  return $serializerClass_6;
}
var $serializer_instance_6;
function $serializer_getInstance_6() {
  if ($serializer_instance_6 === VOID)
    new ($serializer_6())();
  return $serializer_instance_6;
}
var VirtualAliasClass;
function VirtualAlias() {
  if (VirtualAliasClass === VOID) {
    class $ {
      constructor(serialName, wraps, annotations) {
        Companion_getInstance_6();
        this.serialName_1 = serialName;
        this.wraps_1 = wraps;
        this.annotations_1 = annotations;
      }
      get_annotations_20dirp_k$() {
        return this.annotations_1;
      }
      toString() {
        return 'VirtualAlias(serialName=' + this.serialName_1 + ', wraps=' + this.wraps_1.toString() + ', annotations=' + toString(this.annotations_1) + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.serialName_1);
        result = imul(result, 31) + this.wraps_1.hashCode() | 0;
        result = imul(result, 31) + hashCode(this.annotations_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualAlias()))
          return false;
        if (!(this.serialName_1 === other.serialName_1))
          return false;
        if (!this.wraps_1.equals(other.wraps_1))
          return false;
        if (!equals(this.annotations_1, other.annotations_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualAlias_mvatuw_k$(seen0, serialName, wraps, annotations, serializationConstructorMarker) {
        Companion_getInstance_6();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_6().descriptor_1);
        }
        var $this = createThis(this);
        $this.serialName_1 = serialName;
        $this.wraps_1 = wraps;
        $this.annotations_1 = annotations;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualAlias', VOID, VOID, [VirtualType()], VOID, VOID, {0: $serializer_getInstance_6});
    VirtualAliasClass = $;
  }
  return VirtualAliasClass;
}
function VirtualSealedOption$Companion$$childSerializers$_anonymous__bs45rm() {
  return new (LinkedHashSetSerializer())(StringSerializer_getInstance());
}
var CompanionClass_7;
function Companion_7() {
  if (CompanionClass_7 === VOID) {
    class $ {
      constructor() {
        Companion_instance_7 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, VirtualSealedOption$Companion$$childSerializers$_anonymous__bs45rm), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_7();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_7 = $;
  }
  return CompanionClass_7;
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new (Companion_7())();
  return Companion_instance_7;
}
var $serializerClass_7;
function $serializer_7() {
  if ($serializerClass_7 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_7 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualSealedOption', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('secondaryNames', false);
        tmp0_serialDesc.addElement_5pzumi_k$('type', false);
        tmp0_serialDesc.addElement_5pzumi_k$('index', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_jevpu8_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_7().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.name_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.secondaryNames_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, $serializer_getInstance_1(), value.type_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 3, value.index_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_jevpu8_k$(encoder, value instanceof VirtualSealedOption() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = 0;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp9_cached = Companion_getInstance_7().$childSerializers_1;
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, $serializer_getInstance_1(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualSealedOption().new_com_lightningkite_services_database_VirtualSealedOption_l1zr2g_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_7().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), $serializer_getInstance_1(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_7 = $;
  }
  return $serializerClass_7;
}
var $serializer_instance_7;
function $serializer_getInstance_7() {
  if ($serializer_instance_7 === VOID)
    new ($serializer_7())();
  return $serializer_instance_7;
}
var VirtualSealedOptionClass;
function VirtualSealedOption() {
  if (VirtualSealedOptionClass === VOID) {
    class $ {
      constructor(name, secondaryNames, type, index) {
        Companion_getInstance_7();
        this.name_1 = name;
        this.secondaryNames_1 = secondaryNames;
        this.type_1 = type;
        this.index_1 = index;
      }
      toString() {
        return 'VirtualSealedOption(name=' + this.name_1 + ', secondaryNames=' + toString(this.secondaryNames_1) + ', type=' + this.type_1.toString() + ', index=' + this.index_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + hashCode(this.secondaryNames_1) | 0;
        result = imul(result, 31) + this.type_1.hashCode() | 0;
        result = imul(result, 31) + this.index_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualSealedOption()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!equals(this.secondaryNames_1, other.secondaryNames_1))
          return false;
        if (!this.type_1.equals(other.type_1))
          return false;
        if (!(this.index_1 === other.index_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualSealedOption_l1zr2g_k$(seen0, name, secondaryNames, type, index, serializationConstructorMarker) {
        Companion_getInstance_7();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_7().descriptor_1);
        }
        var $this = createThis(this);
        $this.name_1 = name;
        $this.secondaryNames_1 = secondaryNames;
        $this.type_1 = type;
        $this.index_1 = index;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualSealedOption', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_7});
    VirtualSealedOptionClass = $;
  }
  return VirtualSealedOptionClass;
}
function VirtualEnumOption$Companion$$childSerializers$_anonymous__nmfs4p() {
  return new (ArrayListSerializer())($serializer_getInstance());
}
var CompanionClass_8;
function Companion_8() {
  if (CompanionClass_8 === VOID) {
    class $ {
      constructor() {
        Companion_instance_8 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, VirtualEnumOption$Companion$$childSerializers$_anonymous__nmfs4p), null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_8();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_8 = $;
  }
  return CompanionClass_8;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new (Companion_8())();
  return Companion_instance_8;
}
var $serializerClass_8;
function $serializer_8() {
  if ($serializerClass_8 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_8 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.VirtualEnumOption', this, 3);
        tmp0_serialDesc.addElement_5pzumi_k$('name', false);
        tmp0_serialDesc.addElement_5pzumi_k$('annotations', false);
        tmp0_serialDesc.addElement_5pzumi_k$('index', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_7zjfnv_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_8().$childSerializers_1;
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.name_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.annotations_1);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.index_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_7zjfnv_k$(encoder, value instanceof VirtualEnumOption() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp8_cached = Companion_getInstance_8().$childSerializers_1;
        if (tmp7_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp7_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp7_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp7_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp8_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp7_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp7_input.endStructure_1xqz0n_k$(tmp0_desc);
        return VirtualEnumOption().new_com_lightningkite_services_database_VirtualEnumOption_wbwmcs_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_8().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_8 = $;
  }
  return $serializerClass_8;
}
var $serializer_instance_8;
function $serializer_getInstance_8() {
  if ($serializer_instance_8 === VOID)
    new ($serializer_8())();
  return $serializer_instance_8;
}
var VirtualEnumOptionClass;
function VirtualEnumOption() {
  if (VirtualEnumOptionClass === VOID) {
    class $ {
      constructor(name, annotations, index) {
        Companion_getInstance_8();
        this.name_1 = name;
        this.annotations_1 = annotations;
        this.index_1 = index;
      }
      toString() {
        return 'VirtualEnumOption(name=' + this.name_1 + ', annotations=' + toString(this.annotations_1) + ', index=' + this.index_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.name_1);
        result = imul(result, 31) + hashCode(this.annotations_1) | 0;
        result = imul(result, 31) + this.index_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualEnumOption()))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!equals(this.annotations_1, other.annotations_1))
          return false;
        if (!(this.index_1 === other.index_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_VirtualEnumOption_wbwmcs_k$(seen0, name, annotations, index, serializationConstructorMarker) {
        Companion_getInstance_8();
        if (!(7 === (7 & seen0))) {
          throwMissingFieldException(seen0, 7, $serializer_getInstance_8().descriptor_1);
        }
        var $this = createThis(this);
        $this.name_1 = name;
        $this.annotations_1 = annotations;
        $this.index_1 = index;
        return $this;
      }
    }
    initMetadataForClass($, 'VirtualEnumOption', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_8});
    VirtualEnumOptionClass = $;
  }
  return VirtualEnumOptionClass;
}
function _get_$cachedSerializer__te6jhj($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function SerializableAnnotationValue$NullValue$_anonymous__fpge3y() {
  var tmp = NullValue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = [];
  return ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('com.lightningkite.services.database.SerializableAnnotationValue.NullValue', tmp, tmp$ret$0);
}
var CompanionClass_9;
function Companion_9() {
  if (CompanionClass_9 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_9();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_9 = $;
  }
  return CompanionClass_9;
}
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var $serializerClass_9;
function $serializer_9() {
  if ($serializerClass_9 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_9 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.BooleanValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_iwt88l_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_iwt88l_k$(encoder, value instanceof BooleanValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = false;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return BooleanValue().new_com_lightningkite_services_database_SerializableAnnotationValue_BooleanValue_vd3fns_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_9 = $;
  }
  return $serializerClass_9;
}
var $serializer_instance_9;
function $serializer_getInstance_9() {
  if ($serializer_instance_9 === VOID)
    new ($serializer_9())();
  return $serializer_instance_9;
}
var CompanionClass_10;
function Companion_10() {
  if (CompanionClass_10 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_10();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_10 = $;
  }
  return CompanionClass_10;
}
var Companion_instance_10;
function Companion_getInstance_10() {
  return Companion_instance_10;
}
var $serializerClass_10;
function $serializer_10() {
  if ($serializerClass_10 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_10 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.ByteValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_fh21n1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeByteElement_kft2ib_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_fh21n1_k$(encoder, value instanceof ByteValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeByteElement_c1pisz_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeByteElement_c1pisz_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ByteValue().new_com_lightningkite_services_database_SerializableAnnotationValue_ByteValue_r5gs5j_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [ByteSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_10 = $;
  }
  return $serializerClass_10;
}
var $serializer_instance_10;
function $serializer_getInstance_10() {
  if ($serializer_instance_10 === VOID)
    new ($serializer_10())();
  return $serializer_instance_10;
}
var CompanionClass_11;
function Companion_11() {
  if (CompanionClass_11 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_11();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_11 = $;
  }
  return CompanionClass_11;
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
var $serializerClass_11;
function $serializer_11() {
  if ($serializerClass_11 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_11 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.ShortValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_bkl9nl_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeShortElement_4bcdph_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_bkl9nl_k$(encoder, value instanceof ShortValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeShortElement_pzg12t_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeShortElement_pzg12t_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ShortValue().new_com_lightningkite_services_database_SerializableAnnotationValue_ShortValue_4gnwtz_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [ShortSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_11 = $;
  }
  return $serializerClass_11;
}
var $serializer_instance_11;
function $serializer_getInstance_11() {
  if ($serializer_instance_11 === VOID)
    new ($serializer_11())();
  return $serializer_instance_11;
}
var CompanionClass_12;
function Companion_12() {
  if (CompanionClass_12 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_12();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_12 = $;
  }
  return CompanionClass_12;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  return Companion_instance_12;
}
var $serializerClass_12;
function $serializer_12() {
  if ($serializerClass_12 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_12 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.IntValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_2u5bm_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_2u5bm_k$(encoder, value instanceof IntValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeIntElement_941u6a_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return IntValue().new_com_lightningkite_services_database_SerializableAnnotationValue_IntValue_enwekc_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_12 = $;
  }
  return $serializerClass_12;
}
var $serializer_instance_12;
function $serializer_getInstance_12() {
  if ($serializer_instance_12 === VOID)
    new ($serializer_12())();
  return $serializer_instance_12;
}
var CompanionClass_13;
function Companion_13() {
  if (CompanionClass_13 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_13();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_13 = $;
  }
  return CompanionClass_13;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  return Companion_instance_13;
}
var $serializerClass_13;
function $serializer_13() {
  if ($serializerClass_13 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_13 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.LongValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_uou09l_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeLongElement_ovnxxh_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_uou09l_k$(encoder, value instanceof LongValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0n;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeLongElement_994anb_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeLongElement_994anb_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return LongValue().new_com_lightningkite_services_database_SerializableAnnotationValue_LongValue_kytg1r_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LongSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_13 = $;
  }
  return $serializerClass_13;
}
var $serializer_instance_13;
function $serializer_getInstance_13() {
  if ($serializer_instance_13 === VOID)
    new ($serializer_13())();
  return $serializer_instance_13;
}
var CompanionClass_14;
function Companion_14() {
  if (CompanionClass_14 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_14();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_14 = $;
  }
  return CompanionClass_14;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  return Companion_instance_14;
}
var $serializerClass_14;
function $serializer_14() {
  if ($serializerClass_14 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_14 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.FloatValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_qqn2db_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeFloatElement_oe8hn_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_qqn2db_k$(encoder, value instanceof FloatValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeFloatElement_p2q55h_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return FloatValue().new_com_lightningkite_services_database_SerializableAnnotationValue_FloatValue_jbaga1_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [FloatSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_14 = $;
  }
  return $serializerClass_14;
}
var $serializer_instance_14;
function $serializer_getInstance_14() {
  if ($serializer_instance_14 === VOID)
    new ($serializer_14())();
  return $serializer_instance_14;
}
var CompanionClass_15;
function Companion_15() {
  if (CompanionClass_15 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_15();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_15 = $;
  }
  return CompanionClass_15;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  return Companion_instance_15;
}
var $serializerClass_15;
function $serializer_15() {
  if ($serializerClass_15 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_15 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.DoubleValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_g4l7z8_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_g4l7z8_k$(encoder, value instanceof DoubleValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return DoubleValue().new_com_lightningkite_services_database_SerializableAnnotationValue_DoubleValue_2qb4ss_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_15 = $;
  }
  return $serializerClass_15;
}
var $serializer_instance_15;
function $serializer_getInstance_15() {
  if ($serializer_instance_15 === VOID)
    new ($serializer_15())();
  return $serializer_instance_15;
}
var CompanionClass_16;
function Companion_16() {
  if (CompanionClass_16 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_16();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_16 = $;
  }
  return CompanionClass_16;
}
var Companion_instance_16;
function Companion_getInstance_16() {
  return Companion_instance_16;
}
var $serializerClass_16;
function $serializer_16() {
  if ($serializerClass_16 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_16 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.CharValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_50nfsx_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeCharElement_5nnekk_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_50nfsx_k$(encoder, value instanceof CharValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = _Char___init__impl__6a9atx(0);
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeCharElement_frbao3_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeCharElement_frbao3_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CharValue().new_com_lightningkite_services_database_SerializableAnnotationValue_CharValue_6yg5a_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [CharSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_16 = $;
  }
  return $serializerClass_16;
}
var $serializer_instance_16;
function $serializer_getInstance_16() {
  if ($serializer_instance_16 === VOID)
    new ($serializer_16())();
  return $serializer_instance_16;
}
var CompanionClass_17;
function Companion_17() {
  if (CompanionClass_17 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_17();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_17 = $;
  }
  return CompanionClass_17;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  return Companion_instance_17;
}
var $serializerClass_17;
function $serializer_17() {
  if ($serializerClass_17 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_17 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.StringValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_l3hz6s_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_l3hz6s_k$(encoder, value instanceof StringValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return StringValue().new_com_lightningkite_services_database_SerializableAnnotationValue_StringValue_217lfp_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_17 = $;
  }
  return $serializerClass_17;
}
var $serializer_instance_17;
function $serializer_getInstance_17() {
  if ($serializer_instance_17 === VOID)
    new ($serializer_17())();
  return $serializer_instance_17;
}
var CompanionClass_18;
function Companion_18() {
  if (CompanionClass_18 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_18();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_18 = $;
  }
  return CompanionClass_18;
}
var Companion_instance_18;
function Companion_getInstance_18() {
  return Companion_instance_18;
}
var $serializerClass_18;
function $serializer_18() {
  if ($serializerClass_18 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_18 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.ClassValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('fqn', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_6ana1x_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 0, value.fqn_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_6ana1x_k$(encoder, value instanceof ClassValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeStringElement_3oenpg_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ClassValue().new_com_lightningkite_services_database_SerializableAnnotationValue_ClassValue_dya9we_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_18 = $;
  }
  return $serializerClass_18;
}
var $serializer_instance_18;
function $serializer_getInstance_18() {
  if ($serializer_instance_18 === VOID)
    new ($serializer_18())();
  return $serializer_instance_18;
}
function SerializableAnnotationValue$ArrayValue$Companion$$childSerializers$_anonymous__qu4khd() {
  return new (ArrayListSerializer())(Companion_getInstance_20().serializer_9w0wvi_k$());
}
var CompanionClass_19;
function Companion_19() {
  if (CompanionClass_19 === VOID) {
    class $ {
      constructor() {
        Companion_instance_19 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [lazy(tmp_0, SerializableAnnotationValue$ArrayValue$Companion$$childSerializers$_anonymous__qu4khd)];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_19();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_19 = $;
  }
  return CompanionClass_19;
}
var Companion_instance_19;
function Companion_getInstance_19() {
  if (Companion_instance_19 === VOID) {
    Companion_getInstance_20();
    new (Companion_19())();
  }
  return Companion_instance_19;
}
var $serializerClass_19;
function $serializer_19() {
  if ($serializerClass_19 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_19 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.services.database.SerializableAnnotationValue.ArrayValue', this, 1);
        tmp0_serialDesc.addElement_5pzumi_k$('value', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_z5ckv0_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_19().$childSerializers_1;
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, tmp2_cached[0].get_value_j01efc_k$(), value.value_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_z5ckv0_k$(encoder, value instanceof ArrayValue() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp6_cached = Companion_getInstance_19().$childSerializers_1;
        if (tmp5_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp6_cached[0].get_value_j01efc_k$(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp5_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp5_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, tmp6_cached[0].get_value_j01efc_k$(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp5_input.endStructure_1xqz0n_k$(tmp0_desc);
        return ArrayValue().new_com_lightningkite_services_database_SerializableAnnotationValue_ArrayValue_uh9m7j_k$(tmp3_bitMask0, tmp4_local0, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [Companion_getInstance_19().$childSerializers_1[0].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_19 = $;
  }
  return $serializerClass_19;
}
var $serializer_instance_19;
function $serializer_getInstance_19() {
  if ($serializer_instance_19 === VOID)
    new ($serializer_19())();
  return $serializer_instance_19;
}
function _get_$cachedSerializer__te6jhj_0($this) {
  return $this.$cachedSerializer$delegate_1.get_value_j01efc_k$();
}
function SerializableAnnotationValue$Companion$_anonymous__pdu2do() {
  var tmp = getKClass(SerializableAnnotationValue());
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_0 = [getKClass(ArrayValue()), getKClass(BooleanValue()), getKClass(ByteValue()), getKClass(CharValue()), getKClass(ClassValue()), getKClass(DoubleValue()), getKClass(FloatValue()), getKClass(IntValue()), getKClass(LongValue()), getKClass(NullValue()), getKClass(ShortValue()), getKClass(StringValue())];
  var tmp_1 = $serializer_getInstance_19();
  var tmp_2 = $serializer_getInstance_9();
  var tmp_3 = $serializer_getInstance_10();
  var tmp_4 = $serializer_getInstance_16();
  var tmp_5 = $serializer_getInstance_18();
  var tmp_6 = $serializer_getInstance_15();
  var tmp_7 = $serializer_getInstance_14();
  var tmp_8 = $serializer_getInstance_12();
  var tmp_9 = $serializer_getInstance_13();
  var tmp_10 = NullValue_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$3 = [];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp_11 = [tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, ObjectSerializer().new_kotlinx_serialization_internal_ObjectSerializer_ezfnxd_k$('com.lightningkite.services.database.SerializableAnnotationValue.NullValue', tmp_10, tmp$ret$3), $serializer_getInstance_11(), $serializer_getInstance_17()];
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$9 = [];
  return SealedClassSerializer().new_kotlinx_serialization_SealedClassSerializer_bm9rfz_k$('com.lightningkite.services.database.SerializableAnnotationValue', tmp, tmp_0, tmp_11, tmp$ret$9);
}
var NullValueClass;
function NullValue() {
  if (NullValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor() {
        NullValue_instance = null;
        super();
        NullValue_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, SerializableAnnotationValue$NullValue$_anonymous__fpge3y);
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
      toString() {
        return 'NullValue';
      }
      hashCode() {
        return -217234918;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof NullValue()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'NullValue', VOID, VOID, [SerializerFactory()], VOID, VOID, {0: NullValue_getInstance});
    NullValueClass = $;
  }
  return NullValueClass;
}
var NullValue_instance;
function NullValue_getInstance() {
  if (NullValue_instance === VOID)
    new (NullValue())();
  return NullValue_instance;
}
var BooleanValueClass;
function BooleanValue() {
  if (BooleanValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'BooleanValue(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getBooleanHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof BooleanValue()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_BooleanValue_vd3fns_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_9().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'BooleanValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_9});
    BooleanValueClass = $;
  }
  return BooleanValueClass;
}
var ByteValueClass;
function ByteValue() {
  if (ByteValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'ByteValue(value=' + this.value_1 + ')';
      }
      hashCode() {
        return this.value_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ByteValue()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_ByteValue_r5gs5j_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_10().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ByteValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_10});
    ByteValueClass = $;
  }
  return ByteValueClass;
}
var ShortValueClass;
function ShortValue() {
  if (ShortValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'ShortValue(value=' + this.value_1 + ')';
      }
      hashCode() {
        return this.value_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ShortValue()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_ShortValue_4gnwtz_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_11().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ShortValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_11});
    ShortValueClass = $;
  }
  return ShortValueClass;
}
var IntValueClass;
function IntValue() {
  if (IntValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'IntValue(value=' + this.value_1 + ')';
      }
      hashCode() {
        return this.value_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof IntValue()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_IntValue_enwekc_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_12().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'IntValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_12});
    IntValueClass = $;
  }
  return IntValueClass;
}
var LongValueClass;
function LongValue() {
  if (LongValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'LongValue(value=' + this.value_1.toString() + ')';
      }
      hashCode() {
        return getBigIntHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof LongValue()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_LongValue_kytg1r_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_13().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'LongValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_13});
    LongValueClass = $;
  }
  return LongValueClass;
}
var FloatValueClass;
function FloatValue() {
  if (FloatValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'FloatValue(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof FloatValue()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_FloatValue_jbaga1_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_14().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'FloatValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_14});
    FloatValueClass = $;
  }
  return FloatValueClass;
}
var DoubleValueClass;
function DoubleValue() {
  if (DoubleValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'DoubleValue(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DoubleValue()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_DoubleValue_2qb4ss_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_15().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'DoubleValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_15});
    DoubleValueClass = $;
  }
  return DoubleValueClass;
}
var CharValueClass;
function CharValue() {
  if (CharValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'CharValue(value=' + toString_0(this.value_1) + ')';
      }
      hashCode() {
        return Char__hashCode_impl_otmys(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CharValue()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_CharValue_6yg5a_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_16().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'CharValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_16});
    CharValueClass = $;
  }
  return CharValueClass;
}
var StringValueClass;
function StringValue() {
  if (StringValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        super();
        this.value_1 = value;
      }
      toString() {
        return 'StringValue(value=' + this.value_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof StringValue()))
          return false;
        if (!(this.value_1 === other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_StringValue_217lfp_k$(seen0, value, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_17().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'StringValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_17});
    StringValueClass = $;
  }
  return StringValueClass;
}
var ClassValueClass;
function ClassValue() {
  if (ClassValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(fqn) {
        super();
        this.fqn_1 = fqn;
      }
      toString() {
        return 'ClassValue(fqn=' + this.fqn_1 + ')';
      }
      hashCode() {
        return getStringHashCode(this.fqn_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClassValue()))
          return false;
        if (!(this.fqn_1 === other.fqn_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_ClassValue_dya9we_k$(seen0, fqn, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_18().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.fqn_1 = fqn;
        return $this;
      }
    }
    initMetadataForClass($, 'ClassValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_18});
    ClassValueClass = $;
  }
  return ClassValueClass;
}
var ArrayValueClass;
function ArrayValue() {
  if (ArrayValueClass === VOID) {
    class $ extends SerializableAnnotationValue() {
      constructor(value) {
        Companion_getInstance_19();
        super();
        this.value_1 = value;
      }
      toString() {
        return 'ArrayValue(value=' + toString(this.value_1) + ')';
      }
      hashCode() {
        return hashCode(this.value_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ArrayValue()))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_ArrayValue_uh9m7j_k$(seen0, value, serializationConstructorMarker) {
        Companion_getInstance_19();
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_19().descriptor_1);
        }
        var $this = this.new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker);
        $this.value_1 = value;
        return $this;
      }
    }
    initMetadataForClass($, 'ArrayValue', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_19});
    ArrayValueClass = $;
  }
  return ArrayValueClass;
}
var CompanionClass_20;
function Companion_20() {
  if (CompanionClass_20 === VOID) {
    class $ {
      constructor() {
        Companion_instance_20 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        tmp.$cachedSerializer$delegate_1 = lazy(tmp_0, SerializableAnnotationValue$Companion$_anonymous__pdu2do);
      }
      invoke_cywwop_k$(value) {
        var tmp;
        if (value == null) {
          tmp = NullValue_getInstance();
        } else {
          if (typeof value === 'boolean') {
            tmp = new (BooleanValue())(value);
          } else {
            if (typeof value === 'number') {
              tmp = new (ByteValue())(value);
            } else {
              if (typeof value === 'number') {
                tmp = new (ShortValue())(value);
              } else {
                if (typeof value === 'number') {
                  tmp = new (IntValue())(value);
                } else {
                  if (typeof value === 'bigint') {
                    tmp = new (LongValue())(value);
                  } else {
                    if (typeof value === 'number') {
                      tmp = new (FloatValue())(value);
                    } else {
                      if (typeof value === 'number') {
                        tmp = new (DoubleValue())(value);
                      } else {
                        if (value instanceof Char()) {
                          tmp = new (CharValue())(value.value_1);
                        } else {
                          if (typeof value === 'string') {
                            tmp = new (StringValue())(value);
                          } else {
                            if (value instanceof Enum()) {
                              tmp = new (StringValue())(value.name_1);
                            } else {
                              if (isInterface(value, KClass())) {
                                var tmp1_safe_receiver = serializerOrNull(value);
                                var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.get_descriptor_wjt6a0_k$();
                                var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.get_serialName_u2rqhk_k$();
                                tmp = new (ClassValue())(tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs);
                              } else {
                                if (isBooleanArray(value)) {
                                  // Inline function 'kotlin.collections.map' call
                                  // Inline function 'kotlin.collections.mapTo' call
                                  var destination = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                  var inductionVariable = 0;
                                  var last = value.length;
                                  while (inductionVariable < last) {
                                    var item = value[inductionVariable];
                                    inductionVariable = inductionVariable + 1 | 0;
                                    var tmp$ret$2 = Companion_getInstance_20().invoke_cywwop_k$(item);
                                    destination.add_utx5q5_k$(tmp$ret$2);
                                  }
                                  tmp = new (ArrayValue())(destination);
                                } else {
                                  if (isByteArray(value)) {
                                    // Inline function 'kotlin.collections.map' call
                                    // Inline function 'kotlin.collections.mapTo' call
                                    var destination_0 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                    var inductionVariable_0 = 0;
                                    var last_0 = value.length;
                                    while (inductionVariable_0 < last_0) {
                                      var item_0 = value[inductionVariable_0];
                                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                                      var tmp$ret$5 = Companion_getInstance_20().invoke_cywwop_k$(item_0);
                                      destination_0.add_utx5q5_k$(tmp$ret$5);
                                    }
                                    tmp = new (ArrayValue())(destination_0);
                                  } else {
                                    if (isShortArray(value)) {
                                      // Inline function 'kotlin.collections.map' call
                                      // Inline function 'kotlin.collections.mapTo' call
                                      var destination_1 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                      var inductionVariable_1 = 0;
                                      var last_1 = value.length;
                                      while (inductionVariable_1 < last_1) {
                                        var item_1 = value[inductionVariable_1];
                                        inductionVariable_1 = inductionVariable_1 + 1 | 0;
                                        var tmp$ret$8 = Companion_getInstance_20().invoke_cywwop_k$(item_1);
                                        destination_1.add_utx5q5_k$(tmp$ret$8);
                                      }
                                      tmp = new (ArrayValue())(destination_1);
                                    } else {
                                      if (isIntArray(value)) {
                                        // Inline function 'kotlin.collections.map' call
                                        // Inline function 'kotlin.collections.mapTo' call
                                        var destination_2 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                        var inductionVariable_2 = 0;
                                        var last_2 = value.length;
                                        while (inductionVariable_2 < last_2) {
                                          var item_2 = value[inductionVariable_2];
                                          inductionVariable_2 = inductionVariable_2 + 1 | 0;
                                          var tmp$ret$11 = Companion_getInstance_20().invoke_cywwop_k$(item_2);
                                          destination_2.add_utx5q5_k$(tmp$ret$11);
                                        }
                                        tmp = new (ArrayValue())(destination_2);
                                      } else {
                                        if (isLongArray(value)) {
                                          // Inline function 'kotlin.collections.map' call
                                          // Inline function 'kotlin.collections.mapTo' call
                                          var destination_3 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                          var inductionVariable_3 = 0;
                                          var last_3 = value.length;
                                          while (inductionVariable_3 < last_3) {
                                            var item_3 = value[inductionVariable_3];
                                            inductionVariable_3 = inductionVariable_3 + 1 | 0;
                                            var tmp$ret$14 = Companion_getInstance_20().invoke_cywwop_k$(item_3);
                                            destination_3.add_utx5q5_k$(tmp$ret$14);
                                          }
                                          tmp = new (ArrayValue())(destination_3);
                                        } else {
                                          if (isFloatArray(value)) {
                                            // Inline function 'kotlin.collections.map' call
                                            // Inline function 'kotlin.collections.mapTo' call
                                            var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                            var inductionVariable_4 = 0;
                                            var last_4 = value.length;
                                            while (inductionVariable_4 < last_4) {
                                              var item_4 = value[inductionVariable_4];
                                              inductionVariable_4 = inductionVariable_4 + 1 | 0;
                                              var tmp$ret$17 = Companion_getInstance_20().invoke_cywwop_k$(item_4);
                                              destination_4.add_utx5q5_k$(tmp$ret$17);
                                            }
                                            tmp = new (ArrayValue())(destination_4);
                                          } else {
                                            if (isDoubleArray(value)) {
                                              // Inline function 'kotlin.collections.map' call
                                              // Inline function 'kotlin.collections.mapTo' call
                                              var destination_5 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                              var inductionVariable_5 = 0;
                                              var last_5 = value.length;
                                              while (inductionVariable_5 < last_5) {
                                                var item_5 = value[inductionVariable_5];
                                                inductionVariable_5 = inductionVariable_5 + 1 | 0;
                                                var tmp$ret$20 = Companion_getInstance_20().invoke_cywwop_k$(item_5);
                                                destination_5.add_utx5q5_k$(tmp$ret$20);
                                              }
                                              tmp = new (ArrayValue())(destination_5);
                                            } else {
                                              if (isCharArray(value)) {
                                                // Inline function 'kotlin.collections.map' call
                                                // Inline function 'kotlin.collections.mapTo' call
                                                var destination_6 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                                var inductionVariable_6 = 0;
                                                var last_6 = value.length;
                                                while (inductionVariable_6 < last_6) {
                                                  var item_6 = value[inductionVariable_6];
                                                  inductionVariable_6 = inductionVariable_6 + 1 | 0;
                                                  var tmp$ret$23 = Companion_getInstance_20().invoke_cywwop_k$(new (Char())(item_6));
                                                  destination_6.add_utx5q5_k$(tmp$ret$23);
                                                }
                                                tmp = new (ArrayValue())(destination_6);
                                              } else {
                                                if (isArray(value)) {
                                                  // Inline function 'kotlin.collections.map' call
                                                  // Inline function 'kotlin.collections.mapTo' call
                                                  var destination_7 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(value.length);
                                                  var inductionVariable_7 = 0;
                                                  var last_7 = value.length;
                                                  while (inductionVariable_7 < last_7) {
                                                    var item_7 = value[inductionVariable_7];
                                                    inductionVariable_7 = inductionVariable_7 + 1 | 0;
                                                    var tmp$ret$26 = Companion_getInstance_20().invoke_cywwop_k$(item_7);
                                                    destination_7.add_utx5q5_k$(tmp$ret$26);
                                                  }
                                                  tmp = new (ArrayValue())(destination_7);
                                                } else {
                                                  tmp = NullValue_getInstance();
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        return tmp;
      }
      serializer_9w0wvi_k$() {
        return _get_$cachedSerializer__te6jhj_0(this);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_9w0wvi_k$();
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_20 = $;
  }
  return CompanionClass_20;
}
var Companion_instance_20;
function Companion_getInstance_20() {
  if (Companion_instance_20 === VOID)
    new (Companion_20())();
  return Companion_instance_20;
}
var SerializableAnnotationValueClass;
function SerializableAnnotationValue() {
  if (SerializableAnnotationValueClass === VOID) {
    class $ {
      constructor() {
        Companion_getInstance_20();
      }
      static new_com_lightningkite_services_database_SerializableAnnotationValue_tcfhup_k$(seen0, serializationConstructorMarker) {
        Companion_getInstance_20();
        return createThis(this);
      }
    }
    initMetadataForClass($, 'SerializableAnnotationValue', VOID, VOID, VOID, VOID, VOID, {0: Companion_getInstance_20});
    SerializableAnnotationValueClass = $;
  }
  return SerializableAnnotationValueClass;
}
var VirtualEnumValueClass;
function VirtualEnumValue() {
  if (VirtualEnumValueClass === VOID) {
    class $ {
      constructor(enum_0, index) {
        this.enum_1 = enum_0;
        this.index_1 = index;
      }
      compareTo_bhk3x3_k$(other) {
        return compareTo(this.index_1, other.index_1);
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_bhk3x3_k$(other instanceof VirtualEnumValue() ? other : THROW_CCE());
      }
      toString() {
        return this.enum_1.options_1.get_c1px32_k$(this.index_1).name_1;
      }
    }
    initMetadataForClass($, 'VirtualEnumValue', VOID, VOID, [Comparable()]);
    VirtualEnumValueClass = $;
  }
  return VirtualEnumValueClass;
}
var VirtualSealedInstanceClass;
function VirtualSealedInstance() {
  if (VirtualSealedInstanceClass === VOID) {
    class $ {
      constructor(option, value) {
        this.option_1 = option;
        this.value_1 = value;
      }
      toString() {
        return 'VirtualSealedInstance(option=' + this.option_1.toString() + ', value=' + toString(this.value_1) + ')';
      }
      hashCode() {
        var result = this.option_1.hashCode();
        result = imul(result, 31) + hashCode(this.value_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof VirtualSealedInstance()))
          return false;
        if (!this.option_1.equals(other.option_1))
          return false;
        if (!equals(this.value_1, other.value_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'VirtualSealedInstance');
    VirtualSealedInstanceClass = $;
  }
  return VirtualSealedInstanceClass;
}
function get_serializableAnnotations(_this__u8e3s4) {
  var tmp;
  if (isInterface(_this__u8e3s4, VirtualType())) {
    tmp = _this__u8e3s4.get_annotations_20dirp_k$();
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = _this__u8e3s4.get_descriptor_wjt6a0_k$().get_annotations_20dirp_k$();
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp0_safe_receiver = Companion_getInstance().parseOrNull_evcrzc_k$(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.add_utx5q5_k$(tmp0_safe_receiver);
      }
    }
    tmp = destination;
  }
  return tmp;
}
function getElementSerializableAnnotations(_this__u8e3s4, index) {
  var tmp;
  if (_this__u8e3s4 instanceof Concrete()) {
    tmp = _this__u8e3s4.struct_1.fields_1.get_c1px32_k$(index).annotations_1;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = _this__u8e3s4.get_descriptor_wjt6a0_k$().getElementAnnotations_omrjs6_k$(index);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var tmp0_safe_receiver = Companion_getInstance().parseOrNull_evcrzc_k$(element);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.add_utx5q5_k$(tmp0_safe_receiver);
      }
    }
    tmp = destination;
  }
  return tmp;
}
//region block: init
Companion_instance_4 = new (Companion_4())();
Companion_instance_9 = new (Companion_9())();
Companion_instance_10 = new (Companion_10())();
Companion_instance_11 = new (Companion_11())();
Companion_instance_12 = new (Companion_12())();
Companion_instance_13 = new (Companion_13())();
Companion_instance_14 = new (Companion_14())();
Companion_instance_15 = new (Companion_15())();
Companion_instance_16 = new (Companion_16())();
Companion_instance_17 = new (Companion_17())();
Companion_instance_18 = new (Companion_18())();
//endregion
//region block: exports
export {
  ArrayValue as ArrayValue2wekmi4tq7xrl,
  ByteValue as ByteValue268mu8q8ola7t,
  ClassValue as ClassValue30nwdpwsxtf64,
  IntValue as IntValue1zne6ymw597q,
  StringValue as StringValue3s88kmb638dp,
  SerializableAnnotation as SerializableAnnotation24zw55nlaus9i,
  VirtualEnumValue as VirtualEnumValue7ord04id8ran,
  Concrete_0 as Concretem3lrryrg4bw0,
  VirtualSealedInstance as VirtualSealedInstance5g5b68tt2zol,
  Concrete as Concretecheft49ifgmy,
  getElementSerializableAnnotations as getElementSerializableAnnotations1pxi95cizsm0v,
  get_serializableAnnotations as get_serializableAnnotations1rie2dpj7h2ce,
  Companion_getInstance as Companion_getInstance2gbof873kqjb4,
  Companion_getInstance_19 as Companion_getInstance1ros06qto3hv2,
  Companion_instance_9 as Companion_instance33wqjxm3zfzx3,
  Companion_instance_10 as Companion_instanced7f59egpynym,
  Companion_instance_16 as Companion_instance2v9aitb9yta1m,
  Companion_instance_18 as Companion_instance255g87ali8q4h,
  Companion_getInstance_20 as Companion_getInstance3qgqr058re7xq,
  Companion_instance_15 as Companion_instance1lwpxmbnz6iur,
  Companion_instance_14 as Companion_instancetgfq5f4oczrl,
  Companion_instance_12 as Companion_instance22rhl5jjczjv3,
  Companion_instance_13 as Companion_instance1em9315zvkjzr,
  NullValue_getInstance as NullValue_getInstance2jbsw90ml8iwr,
  Companion_instance_11 as Companion_instance2xygx2n0705wi,
  Companion_instance_17 as Companion_instance3olmodtpz49ra,
  Companion_getInstance_6 as Companion_getInstance3vgjjqthbx88p,
  Companion_getInstance_3 as Companion_getInstance1sv7pt72vq00c,
  Companion_getInstance_8 as Companion_getInstancevnkc3zf23j20,
  Companion_getInstance_0 as Companion_getInstancerpzvysyka08o,
  Companion_getInstance_5 as Companion_getInstance6160e1yv7jen,
  Companion_getInstance_7 as Companion_getInstance3a8144f02tjl2,
  Companion_getInstance_2 as Companion_getInstance184rpyho39fqw,
  Companion_instance_4 as Companion_instance1euxei6nfs2w0,
  Companion_getInstance_1 as Companion_getInstance27tg9jz4geu2v,
};
//endregion

//# sourceMappingURL=VirtualType.mjs.map
